export default __webpack_public_path__ + "static/media/cardbeneficio.20d74df5.png";